module.exports = __webpack_public_path__ + "e626d2c7d3f6760bd944b9a9f520ebc3.woff2";